import styled from 'styled-components';

const Header = styled.h1`
  color: ${props => props.theme.color1};
  margin-top: 0;
  text-decoration: underline;
`;

export default Header;